import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CategoryTilesSkeleton = ({ tileCount = 8 }) => {
  return (
    <div className="mb-8">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4">
        {Array(tileCount)
          .fill()
          .map((_, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md border border-[#ededed] p-4 transition-all duration-300 hover:border-gray-300 hover:shadow-lg"
            >
              {/* Category image skeleton */}
              <div className="relative mb-3">
                <Skeleton
                  height={120}
                  baseColor="#f8fafc"
                  highlightColor="#e2e8f0"
                  className="!rounded-lg"
                />
              </div>

              {/* Category title skeleton */}
              <Skeleton
                height={16}
                width="80%"
                baseColor="#f1f5f9"
                highlightColor="#e2e8f0"
                className="mx-auto !rounded-sm"
              />
            </div>
          ))}
      </div>
    </div>
  )
}

export default CategoryTilesSkeleton
